import './index.scss'
import {memo} from 'react'
import {Link} from 'react-router-dom'
import classNames from 'classnames'
import {ArrowRightIcon} from '../../../icons'
import {colors} from '../../../utils/colors'
import {useSelector} from 'react-redux'

const INDEX_ZERO = 0
const Breadcrumb = ({data = []}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <div className={classNames('breadcrumbs', {
            dark: isDarkMode
        })}>
            {data.map((item, index) => {
                const isLinkItem = typeof item === 'object' && !item?.props

                return (
                    <span
                        key={index}
                        className={classNames({
                            'd-flex align-items-center gap-half': isLinkItem || index !== INDEX_ZERO
                        })}
                    >
                        {index !== INDEX_ZERO && (
                            <span className="d-flex arrow-icon">
                                <ArrowRightIcon color={colors.colorSlateBlue} />
                            </span>
                        )}
                        {isLinkItem ? (
                            <Link className="link" to={item.path}>
                                {item.title}
                            </Link>
                        ) : (
                            <span>{item}</span>
                        )}
                    </span>
                )
            })}
        </div>
    )
}

export default memo(Breadcrumb)
